// import cx from 'classnames'
import useSWR from 'swr';
import { useCallback, useEffect, useState } from 'react';
import { Button } from 'Elements';
import { setSelectedMarker } from 'Actions';
import { api } from 'Utils';
import { useDispatch } from 'react-redux';
import { CaretLeft, CaretRight } from 'tabler-icons-react';
import styles from 'partials/story-line.module.scss';

export const StoryLine = ({ story }) => {
	const dispatch = useDispatch();
	const [id, setId] = useState(null);
	const { data } = useSWR(id ? api.getStoryDetail(id) : null);

	const handleStory = (id) => {
		setId(id);
	};

	const setData = useCallback(() => {
		if (data) {
			dispatch(setSelectedMarker(data.list));
		}
	}, [dispatch, data]);

	useEffect(() => {
		setData();
	}, [setData]);

	return (
		<div className={styles.bar}>
			{story.children && (
				<Button
					className={styles.arrow}
					onClick={() => handleStory(story.children)}>
					<CaretRight size={26} />
				</Button>
			)}
			<div className={styles.center}>
				<span className={styles.tag}>
					دنباله دار
					<span className={styles.count}>{story.section_number}</span>
				</span>
			</div>
			{story.parent && (
				<Button
					className={styles.arrow}
					onClick={() => handleStory(story.parent)}>
					<CaretLeft size={26} />
				</Button>
			)}
		</div>
	);
};
